import * as z from 'zod';

export const NonEmptyStringSchema = z.string().min(1, { message: 'Required' });

export const OptionalStringSchema = z.string().optional();

export const OptionalStringArraySchema = z.array(z.string()).optional();
